// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}

.price {
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: end;
  color: var(--ion-color-primary-text);
}

ion-label {
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary-text) !important;
}
ion-label span {
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary-text) !important;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #ffffff;
  border-radius: var(--radius-default);
  margin-top: 10px;
  border: var(--outline-default);
}

.pfand {
  font-size: 10px;
}

ion-icon {
  display: inline-block;
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
  vertical-align: sub;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AAEA;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,eAAA;EACA,oCAAA;AAAD;;AAGA;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+CAAA;AAAD;AAEC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+CAAA;AAAF;;AAIA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AADD;;AAIA;EACC,qBAAA;AADD;;AAGA;EACC,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,8BAAA;AAAD;;AAGA;EACC,eAAA;AAAD;;AAGA;EACC,qBAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAAD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\n.price {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\ttext-align: end;\n\tcolor: var(--ion-color-primary-text);\n}\n\nion-label {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-primary-text) !important;\n\n\tspan {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 16px;\n\t\tline-height: 128%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-primary-text) !important;\n\t}\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder-radius: var(--radius-default);\n\tmargin-top: 10px;\n\tborder: var(--outline-default);\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-icon {\n\tdisplay: inline-block;\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n\tvertical-align: sub;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
